// extracted by mini-css-extract-plugin
module.exports = {"textarea":"_2q5H39-"};